
import { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { getLocalStoreItem, setLocalStoreItem } from "../../../../helpers/localStoreHandler";
import { SET_BRAND_LOCALE } from "../../../../actions/types";
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import style from './style.module.css';
import BmpLayout from '../../bmp-Layout';
import { getBrandLocaleData } from '../../utils/brand-locale';

let prevBrand = {brand: '', locale: ''};

export default function BmpLanding() {
    const dispatch = useDispatch();
    const history = useHistory();
    const [error, setError] = useState('');
    const [brandData, setBrandData] = useState([]);
    const [localeData, setLocaleData] = useState([]);
    const [formData, setFormData] = useState({});
  
    useEffect(()=>{
        let isMounted = true;
        const getLocale = getLocalStoreItem('bmpSelectedLocale');
        if (isMounted && getLocale) {
            const data = JSON.parse(getLocale);
            setFormData({...data});
            prevBrand = {brand: data.brand.value, locale: data.locale.value};
        }
        const loadData = async () => {
            const result = await getBrandLocaleData();
            if (isMounted) { 
                setBrandData(result.brands);
                setLocaleData(result.brandLocales);
            }
        };
        if (isMounted) {    
            loadData();
        }
        return () => {
            isMounted = false; // Cleanup function to set flag to false
        };
    },[]);
    
    const handleChange = (event, name) => {
        setFormData(prev => {
            return {
                ...prev,
                [name]: { ...event }
            }
        });
        setError('');
    };

    const submitHandler = (e) => {
        e.preventDefault();
        if (formData?.brand?.value && formData?.locale?.value) {
            dispatch({
                type: SET_BRAND_LOCALE, 
                payload: {
                    brand: {...formData.brand}, 
                    locale: {...formData.locale}
                } 
            });
            setLocalStoreItem('bmpSelectedLocale', JSON.stringify(formData));
            if (prevBrand.brand !== formData.brand.value || prevBrand.locale !== formData.locale.value) {
                localStorage.removeItem('pdpFaqChangesState');
            }
            setError('');
            history.push('/dashboard/brand-manager-portal/review-summary');
        } else {
            setError("Please select Brand & Locale");
        }
    }

    const emptyLocale = [{value: '', label: ''}];
    const localeOptions = Object.keys(localeData)?.length > 0 ? formData?.brand?.value ? localeData?.[formData?.brand?.value] : Array.from(new Map(Object.values(localeData).flat().filter(item => item.value !== "").map(item => [item.value, item])).values()) : emptyLocale;
    
    return (
        <BmpLayout>
            <div className={style.container}>
                <div className={style["brand-selector"]}>
                    {/* <img src={unilverLogo} alt="Unilever Logo" className={style.logo} /> */}
                    <h1>Select Brand Market</h1>
                    <p>Select your Brand and Market to configure your Brand Manager Portal. This ensures the Portal shows AI summaries, FAQs and content specific to your context.</p>
                    
                    <form onSubmit={submitHandler}>
                        <FormGroup className={style.formGroup}>
                            <Autocomplete
                                value={formData.brand || null}
                                onChange={(event, newValue) => handleChange(newValue, 'brand')}
                                className={style.autocomplete} 
                                options={brandData}
                                size='small'
                                getOptionLabel={(option) => (!option || Object.keys(option).length === 0) ? '' : (option.label || '')}
                                isOptionEqualToValue={(option, value) => option.value === value?.value || {}}
                                // filterOptions={(options, { inputValue }) => {
                                //     return inputValue.trim() === '' ? options.filter(item => item.value !== '') : options;
                                // }}
                                renderInput={(params) => <TextField {...params} label="Select Brand" />} 
                            />
                            <Autocomplete
                                value={formData.locale || null}
                                onChange={(event, newValue) => handleChange(newValue, 'locale')}
                                className={style.autocomplete}
                                options={localeOptions}
                                size='small'
                                getOptionLabel={(option) => (!option || Object.keys(option).length === 0) ? '' : (option.label || '')}
                                isOptionEqualToValue={(option, value) => option.value === value?.value || {}}
                                // filterOptions={(options, { inputValue }) => {
                                //     return inputValue.trim() === '' ? options.filter(item => item.value !== '') : options;
                                // }}
                                renderInput={(params) => <TextField {...params} label="Select Locale" />}
                            />
                        </FormGroup>
                        {error && <p className={style.error}>{error}</p>}
                        <Button type="submit" variant="contained" sx={{width: '100%', height: '50px', marginTop: '25px'}}>Continue to Portal</Button>;
                    </form>  
                </div>
            </div>
        </BmpLayout>
    )
}